/**
 * Hook de catálogo — Portal Cliente Menuee
 *
 * Delega toda lectura a productosService. Sin consultas Supabase directas.
 */

import { useState, useEffect } from "react";
import { getCatalogo } from "../services/productosService";

export function useProductos(sucursalId, localId) {
  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [extras, setExtras] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    let cancelado = false;

    async function cargarProductos() {
      if (!sucursalId) {
        setProductos([]);
        setCategorias([]);
        setExtras([]);
        return;
      }

      setCargando(true);

      try {
        const catalogo = await getCatalogo(sucursalId, localId || null);
        if (!cancelado) {
          setProductos(catalogo.productos);
          setCategorias(catalogo.categorias);
          setExtras(catalogo.extras || []);
        }
      } catch (error) {
        console.error("Error cargando catálogo:", error);
        if (!cancelado) {
          setProductos([]);
          setCategorias([]);
          setExtras([]);
        }
      } finally {
        if (!cancelado) {
          setCargando(false);
        }
      }
    }

    cargarProductos();

    return () => {
      cancelado = true;
    };
  }, [sucursalId, localId]);

  return { productos, categorias, extras, cargando };
}
